import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.mememall.tv/api/', 
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response, 
  (error) => {
    console.error('API Error:', error.response || error.message);
    return Promise.reject(error);
  }
);

export default api;
